<template>
    <component v-bind:is="componentType" v-bind="attributes" @input="inputEvent" />
</template>
<script>
export default {
    props: {
        componentType: { type: String, required: true },
        attributes: { type: Object },
        inputEvent: { type: Function, default: function() {} }
    }
};
</script>

<style></style>
